<template>
    <div class="w-full flex flex-col justify-center items-center" style=" min-height:100px">
        <header class=" w-full h-[88px] lg:h-[140px] z-49">
        </header>
        <NewSlide class="h-[calc(100vh-88px)] lg:h-[calc(100vh-140px)]" />
        <div class="flex flex-col w-full items-center justify-center h-full min-h-[690px] bg-white">
            <div class="flex flex-col w-full items-center justify-center text-center px-4">
                <p class="text-gray-700 font-serif text-4xl leading-9 mb-2">S&oacute;lo el conocimiento hace superior al hombre.</p>
                <p class="text-2xl leading-11 text-hgold text-center font-serif font-medium tracking-[.75em] mb-12">Desde 1979</p>
                <div class="h-full min-h-[320px]">
                    <EgresadosHuma :types="'QueEsHumanitas'" class="mb-12 "/>
                </div>
                <p class="text-2xl leading-7 text-gray-700 font-sans">Conoce m&aacute;s acerca de nuestros</p>
                <h2 class="text-hwine font-serif text-3xl leading-10">Modelos Acad&eacute;micos</h2>
            </div>
        </div>
        <div class="lg:flex items-center mt-8 justify-center lg:mb-12 w-full max-w-4xl h-full min-h-[320px] lg:max-w-[1200px]">
            <div v-for="(image, index) in images" :key="index" class="flex items-center justify-center lg:mb-0 min-h-[320px] mb-6 max-w-4xl w-full lg:max-w-[1200px]">
                <InfoTresImagenes :img="image.src" :titulo="image.nombre" :alt="image.alt" :enlace="image.link" :descrip="image.describ"  />
            </div>
        </div>
        <CompIndex />
    </div>
    <div class="popad-container"></div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import CompIndex from './components/CompIndex.vue';


const images = ref([
  {
    src: "/pagesImages/ejecutivo-BLANCO.webp",
    link: "https://humanitas.edu.mx/ejecutivo",
    nombre: "EJECUTIVO",
    alt: "Modelo ejecutivo",
    describ: "Está diseñado especialmente para personas que trabajan o tienen múltiples actividades. Las clases se imparten una vez por semana.",
  },
  {
    src: "/pagesImages/escolarizado-BLANCO.webp",
    link: "https://humanitas.edu.mx/escolarizado",
    nombre: "ESCOLARIZADO",
    alt: "Modelo escolarizado",
    describ: "Especialmente para recién egresados de preparatoria, ofreciendo una experiencia educativa presencial de lunes a jueves.",
  },
  {
    src: "/pagesImages/virtual-BLANCO.webp",
    link: "https://humanitas.edu.mx/virtual",
    nombre: "VIRTUAL",
    alt: "Modelo virtual",
    describ: "Ideal para personas que, por diversas razones, no pueden asistir presencialmente a clases.",
  },
]);


</script>

<style>

</style>
